import "bootstrap/dist/css/bootstrap.min.css";
import {
    GetBadgeWrap,
    GetBadgeBox,
    GetBadgeTitle,
    GetBadgeCode,
    GetBadgeTop,
    GetBadgeCodeWrite
} from "./scriptCodeBoxStyle";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const ScriptCodeBox = ({ color }: { color: number | string }) => {
    const { id } = useParams();
    const nonProfitData = useSelector((state: any) => state.nonprofitStats?.data?.results)

    const badges =
    {
        id: 1,
        urls: {
            logo: `https://greatnonprofits.org/badge/simple_${color}_new/${nonProfitData?.title}`,
            star: `https://greatnonprofits.org/badge/stars${color}_new/${nonProfitData?.title}`,
            mini: `https://greatnonprofits.org/badge/mini_${color}_new/${nonProfitData?.title}`
        },
        scripts: {
            logo: `<script type="text/javascript">
    gnp_url = '${nonProfitData?.title}';gnp_num = '${color}';
</script>
<script src="https://new.greatnonprofits.org/js/api/
badge_simple.js" type="text/javascript"></script>
<noscript> <a href="https://new.greatnonprofits.org/org/
${nonProfitData?.title}/?badge=${color}"> <img alt="Review ${nonProfitData?.title} on Great
Nonprofits" title="Review ${nonProfitData?.title} on Great Nonprofits" 
src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?
id=${id}"> </a></noscript>`,
            star: `<script type="text/javascript">
    gnp_url = '${nonProfitData?.title}';gnp_num = '${color}';
</script>
<script src="https://new.greatnonprofits.org/js/api/
badge_stars.js" type="text/javascript"></script>
<noscript> <a href="https://new.greatnonprofits.org/org/
${nonProfitData?.title}/?badge=${color}"> <img alt="Review ${nonProfitData?.title} on Great 
Nonprofits" title="Review ${nonProfitData?.title} on Great Nonprofits" 
src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?
id=${id}"> </a></noscript>`,
            mini: `<script type="text/javascript">
    gnp_url = '${nonProfitData?.title}';gnp_num = '${color}';
</script>
<script src="https://new.greatnonprofits.org/js/api/
badge_mini.js" type="text/javascript"></script>
<noscript> <a href="https://new.greatnonprofits.org/org/
${nonProfitData?.title}/?badge=${color}"> <img alt="Review ${nonProfitData?.title} on Great 
Nonprofits" title="Review ${nonProfitData?.title} on Great Nonprofits" 
src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?
id=${id}"> </a></noscript>`
        }
    }

    return (
        <GetBadgeWrap>
            <GetBadgeBox>
                <GetBadgeTop>
                    <GetBadgeTitle>Logo Badge</GetBadgeTitle>
                    <GetBadgeCodeWrite >
                        <iframe src={badges?.urls?.logo} title="logo_badge" width="135" height="172"></iframe>
                    </GetBadgeCodeWrite>

                </GetBadgeTop>

                <GetBadgeCode className="get-badge-code-wrap">
                    <pre>{badges?.scripts?.logo}</pre>
                </GetBadgeCode>

            </GetBadgeBox>

            <GetBadgeBox>
                <GetBadgeTop>
                    <GetBadgeTitle>Star Badge</GetBadgeTitle>
                    <iframe src={badges?.urls?.star} title="star_badge" width="135" height="172"></iframe>
                </GetBadgeTop>

                <GetBadgeCode className="get-badge-code-wrap">
                    <pre>{badges?.scripts?.star}</pre>
                </GetBadgeCode>

            </GetBadgeBox>

            <GetBadgeBox>
                <GetBadgeTop>
                    <GetBadgeTitle>Mini Badge</GetBadgeTitle>
                    <iframe src={badges?.urls?.mini} title="mini_badge" width="135" height="172" className="minbug-ifame"></iframe>

                </GetBadgeTop>

                <GetBadgeCode className="get-a-badge-code">
                    <pre>{badges?.scripts?.mini}</pre>
                </GetBadgeCode>
            </GetBadgeBox>
        </GetBadgeWrap>
    );
}

export default ScriptCodeBox;